/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pctsol_field_volume = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solution volume`)
};

const es_pctsol_field_volume = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volumen de la solución`)
};

const de_pctsol_field_volume = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lösungsvolumen`)
};

const nl_pctsol_field_volume = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume oplossing`)
};

const fr_pctsol_field_volume = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume de la solution`)
};

const it_pctsol_field_volume = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume della soluzione`)
};

const pt_br2_pctsol_field_volume = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume da solução`)
};

const pt_pctsol_field_volume = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume da solução`)
};

const ja_pctsol_field_volume = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`溶液体積`)
};

const zh_pctsol_field_volume = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`溶液体积`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pctsol_field_volume = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pctsol_field_volume(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pctsol_field_volume", locale)
	if (locale === "en") return en_pctsol_field_volume(inputs)
	if (locale === "es") return es_pctsol_field_volume(inputs)
	if (locale === "de") return de_pctsol_field_volume(inputs)
	if (locale === "nl") return nl_pctsol_field_volume(inputs)
	if (locale === "fr") return fr_pctsol_field_volume(inputs)
	if (locale === "it") return it_pctsol_field_volume(inputs)
	if (locale === "pt-BR") return pt_br2_pctsol_field_volume(inputs)
	if (locale === "pt") return pt_pctsol_field_volume(inputs)
	if (locale === "ja") return ja_pctsol_field_volume(inputs)
	return zh_pctsol_field_volume(inputs)
};